// @ts-nocheck
// TODO: align with current types (Phase 4a) — bucket 2/3 + DS strictness regressions
/**
 * User Edit Modal
 *
 * Modal dialog for editing existing users.
 */

import React from 'react';
import { useUpdateUser } from '../../hooks';
import { FormModal } from '../shared';
import { UserForm, type UserFormData } from './UserForm';
import { useToast } from '@lognai/synapse-design-system-v2';
import type { User } from '@lognai/core-platform';

export interface UserEditModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user: User;
  onSuccess?: () => void;
}

export function UserEditModal({ open, onOpenChange, user, onSuccess }: UserEditModalProps) {
  const { toast } = useToast();
  const updateUser = useUpdateUser();
  const [formRef, setFormRef] = React.useState<HTMLFormElement | null>(null);

  const handleSubmit = async (data: UserFormData) => {
    try {
      await updateUser.mutateAsync({ userId: user.id, data });

      toast({
        title: 'User updated',
        description: `Successfully updated user ${data.email}`,
      });

      onOpenChange(false);
      onSuccess?.();
    } catch (error) {
      toast({
        title: 'Error',
        description: error instanceof Error ? error.message : 'Failed to update user',
        variant: 'destructive',
      });
    }
  };

  return (
    <FormModal
      open={open}
      onOpenChange={onOpenChange}
      title="Edit User"
      description={`Update details for ${user.email}`}
      size="md"
      submitLabel="Save Changes"
      isSubmitting={updateUser.isPending}
      onSubmit={() => {
        // Trigger form submission from FormModal
        formRef?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }}
    >
      <div ref={(ref) => setFormRef(ref?.querySelector('form') || null)}>
        <UserForm user={user} onSubmit={handleSubmit} isSubmitting={updateUser.isPending} />
      </div>
    </FormModal>
  );
}